/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询支付方式
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class GetPayWayDescParams {
  constructor(public code?: string) {}
}

export default async function (
  params: GetPayWayDescParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: string;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/dictionary/payDesc`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
